<template>
<div>
    <StatusBar />
    <nav class="topnav">
        <router-link to="/" class="brand">
            <div class="brand-mark"></div>
            <div class="brand-text">ASO<em>Radar</em></div>
        </router-link>

        <button class="nav-burger" :class="{open: navOpen}" @click="navOpen = !navOpen" aria-label="Toggle navigation" :aria-expanded="navOpen ? 'true' : 'false'" aria-controls="site-nav-links">
            <span></span><span></span><span></span>
        </button>

        <div class="nav-links" id="site-nav-links" :class="{open: navOpen}" @click="navOpen = false">
            <router-link to="/startapp" class="nav-magic">// STARTAPP</router-link>
            <router-link to="/mcp">// MCP</router-link>
            <a :href="`${$state.siteProto}://api.${$state.siteDomain}/docs`" target="_blank" rel="noopener">// API</a>
            <router-link to="/docs">// Documentation</router-link>
            <router-link to="/features">// Features</router-link>
            <router-link to="/pricing">// Pricing</router-link>
            <router-link to="/reviews">// Reviews</router-link>
            <router-link to="/faq">// FAQ</router-link>
            <router-link to="/status">// Status</router-link>
        </div>

        <div class="nav-cta">
            <template v-if="$state.context.id">
                <router-link to="/dashboard" class="btn-amber">▶ Console</router-link>
            </template>
            <template v-else>
                <router-link to="/login" class="btn-ghost">Login</router-link>
                <router-link to="/registration" class="btn-amber">▶ Register</router-link>
            </template>
        </div>
    </nav>
    <main>
        <router-view></router-view>
    </main>
    <Footer />
</div>
</template>

<script>
import Footer from './Footer'
import StatusBar from './StatusBar'
export default {
    components: { Footer, StatusBar },
    data() { return { navOpen: false } },
    watch: { $route() { this.navOpen = false } },
}
</script>
